import Box from "@mui/material/Box";

import type { TitledLine } from "@/libs/tournamentSetupApi";

import { SetupCard, tone } from "./ui";

/** What the Create button writes, from the server preview (F1). */
export function WhatGetsCreated({ lines }: { lines: TitledLine[] }) {
  return (
    <SetupCard title="What gets created">
      <Box sx={{ p: "4px 14px 6px" }}>
        {lines.map((line, index) => (
          <Box
            key={line.title}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 1.5,
              py: "7px",
              borderBottom: index === lines.length - 1 ? 0 : `1px solid ${tone.divider}`,
              fontSize: 12.5,
            }}
          >
            <Box component="span" sx={{ color: tone.muted }}>
              {line.title}
            </Box>
            <Box component="b" sx={{ fontWeight: 700, textAlign: "right", maxWidth: 210 }}>
              {line.detail}
            </Box>
          </Box>
        ))}
      </Box>
    </SetupCard>
  );
}
